import React from 'react';
import useAppStore from '../../store';
import { formatClock } from '../../lib/formatters/time';

function AuditTrailTable() {
  const auditTrail = useAppStore((state) => state.auditTrail);

  if (auditTrail.length === 0) {
    return (
      <div className="audit-empty">
        <p>No console commands recorded yet.</p>
        <span>Every command prompt entry and emergency action lands here.</span>
      </div>
    );
  }

  return (
    <div className="audit-table-wrap">
      <table className="audit-table">
        <thead>
          <tr>
            <th scope="col">When</th>
            <th scope="col">Actor</th>
            <th scope="col">Action</th>
            <th scope="col">Detail</th>
            <th scope="col">Result</th>
          </tr>
        </thead>
        <tbody>
          {[...auditTrail].reverse().map((entry) => (
            <tr key={entry.id}>
              <td>{formatClock(entry.timestamp)}</td>
              <td>{entry.actor}</td>
              <td><code>{entry.action}</code></td>
              <td>{entry.detail}</td>
              <td><span className={`audit-result audit-result--${entry.result}`}>{entry.result}</span></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AuditTrailTable;
